import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const state = {
	accountData: {
		ownerName: "John smith",
		caseNumber: "#568423",
		caseStatus: "Coplete",
		accountAddress: "121 Main St, Northbrook",
		pin: "PIN: 01-01-100-001-0000",
		lastChecked: "12/12/19",
		cardnumber: "****-9999",
		cardAddress: "25 north point",
		amount: "$99",
		lastPayment: "12/12/19",
		paypalEmail: "mail@mail.com",
		paypalUser: "Joe Smith",
  },
  user: {

  }
};

export default {
	state,
	getters,
	actions,
	mutations,
};
